import React from 'react';

import { IconProps } from './type';

const StarIcon: React.FC<IconProps> = ({ size = 24, className = '', ...props }) => (
  <svg
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.43385 8.01512L2.87739 8.97013L2.79798 8.98674C2.01987 9.17918 1.72695 10.1502 2.2999 10.7359L6.23002 14.7535L5.42752 20.299L5.41905 20.3767C5.3609 21.1726 6.20093 21.751 6.93941 21.3903L12 18.9178L17.0606 21.3903L17.1323 21.4223C17.8763 21.7232 18.6896 21.1082 18.5725 20.299L17.7694 14.7535L21.7001 10.7359L21.7545 10.6761C22.2702 10.066 21.9326 9.10938 21.1226 8.97013L15.5656 8.01512L12.9344 3.05981C12.538 2.3134 11.462 2.3134 11.0656 3.05981L8.43385 8.01512Z"
      fill="currentColor"
    />
  </svg>
);

export default StarIcon;
